/** PatientPortalApi (App Service patient-portal-api). */
const DEFAULT_API_URL =
  'https://patient-portal-api-aneqcyf5hkdqejgr.southcentralus-01.azurewebsites.net'

/**
 * Base URL for the PatientPortalApi Axios instance.
 *
 * - `vite` dev: `/api`, which the Vite proxy forwards to the API (no CORS).
 * - Builds: `VITE_APP_API_URL`, or the PatientPortalApi App Service when it is unset or blank.
 */
export function getApiBaseUrl(): string {
  if (import.meta.env.DEV) return '/api'
  return import.meta.env.VITE_APP_API_URL?.trim() || DEFAULT_API_URL
}
